(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["rivage-chat-liquid-glass"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rivage-chat-launcher')) {
    customElements.define('rivage-chat-launcher', class extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('.rivage-chat-launcher__button');
        this.hint = this.querySelector('.rivage-chat-launcher__teaser');
        this.hint.textContent = this.dataset.teaser || '';
        this.openChat = () => {
          if (!this.chat) return;
          this.interacted = true;
          clearTimeout(this.timer);
          this.removeAttribute('data-hint');
          this.chat.setAttribute('open', '');
        };
        this.button.addEventListener('click', this.openChat);
        this.hint.addEventListener('click', this.openChat);
        this.findChat = () => {
          const chat = document.querySelector('shopify-chat');
          if (!chat || !customElements.get('shopify-chat')) return;
          this.chat = chat;
          chat.setAttribute('data-rivage-launcher', '');
          this.discovery.disconnect();
          this.state = new MutationObserver(() => this.sync());
          this.state.observe(chat, { attributes: true, attributeFilter: ['open'] });
          this.sync();
          this.scheduleHint();
        };
        this.discovery = new MutationObserver(this.findChat);
        this.discovery.observe(document.documentElement, { childList: true, subtree: true });
        customElements.whenDefined('shopify-chat').then(() => { if (this.isConnected) this.findChat(); });
        this.findChat();
      }
      sync() {
        const open = this.chat.hasAttribute('open');
        this.hidden = open;
        this.button.setAttribute('aria-expanded', String(open));
        if (open) {
          this.interacted = true;
          clearTimeout(this.timer);
          this.removeAttribute('data-hint');
        }
      }
      scheduleHint() {
        if (this.interacted || !this.hint.textContent || !this.isConnected) return;
        this.timer = setTimeout(() => {
          if (this.interacted || !this.isConnected) return;
          if (!document.hidden) {
            this.setAttribute('data-hint', '');
            this.hint.tabIndex = 0;
          }
          this.timer = setTimeout(() => {
            this.removeAttribute('data-hint');
            this.hint.tabIndex = -1;
            this.scheduleHint();
          }, 4000);
        }, 10000 + Math.random() * 5000);
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        this.discovery?.disconnect();
        this.state?.disconnect();
        this.chat?.removeAttribute('data-rivage-launcher');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rivage-club-popup"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('rivage-membership')) {
  customElements.define('rivage-membership', class extends HTMLElement {
    connectedCallback() {
      if(this.started) return;
      this.started = true;
      this.abort = new AbortController();
      const options = {signal:this.abort.signal};
      this.club = this.querySelector('[data-club-dialog]');
      this.editor = this.dataset.editor === 'true';
      if(this.dataset.pageType !== 'index' || /^\/(challenge|checkpoint)(\/|$)/.test(location.pathname)) return;
      this.api = null;
      const pendingKey = 'rc-club-pending-' + this.dataset.sectionId;
      if(this.editor && this.dataset.preview === 'club' && this.querySelector('[data-club-success]')) {
        let pending = false;
        try {pending = sessionStorage.getItem(pendingKey) === 'yes'; sessionStorage.removeItem(pendingKey);} catch {}
        if(!pending) {
          const cleanUrl = new URL(location.href);
          cleanUrl.searchParams.delete('customer_posted');
          cleanUrl.hash = '';
          if(cleanUrl.href !== location.href) {location.replace(cleanUrl.href); return;}
        }
      }
      this.club.querySelector('form').addEventListener('submit', () => {
        try {sessionStorage.setItem(pendingKey,'yes');} catch {}
      }, options);
      this.previousOverflow = null;
      this.club.querySelector('[data-close-club]').addEventListener('click', () => this.closeClub(), options);
      this.club.addEventListener('cancel', event => {event.preventDefault(); this.closeClub();}, options);
      this.club.addEventListener('click', event => {
        if(event.target === this.club) {
          const r = this.club.getBoundingClientRect();
          if(event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) this.closeClub();
        }
      }, options);
      this.querySelectorAll('[data-interest]').forEach(input => input.addEventListener('change', () => {
        this.querySelector('[data-club-tags]').value = ['newsletter','rivage-club','rivage-members',...[...this.querySelectorAll('[data-interest]:checked')].map(el => el.value)].join(',');
      }, options));
      document.addEventListener('visitorConsentCollected', () => {
        clearTimeout(this.timer);
        this.timer = setTimeout(() => this.scheduleClub(),500);
      }, options);
      document.addEventListener('visibilitychange', () => {if(!document.hidden) this.scheduleClub();}, options);
      document.addEventListener('click', event => {
        const link = event.target.closest('a[href="#rivage-club"]');
        if(link) {event.preventDefault(); this.show();}
      }, options);
      document.addEventListener('rivage:open-club', () => this.show(), options);
      document.addEventListener('shopify:section:select', event => {
        if(event.detail.sectionId === this.dataset.sectionId && this.dataset.preview !== 'off') this.show();
      }, options);
      document.addEventListener('shopify:section:deselect', event => {
        if(event.detail.sectionId === this.dataset.sectionId) this.hide();
      }, options);
      const result = location.hash === '#' + this.club.querySelector('form').id || new URLSearchParams(location.search).get('customer_posted') === 'true';
      this.hasResult = result && (Boolean(this.querySelector('[data-club-errors]')) || (Boolean(this.querySelector('[data-club-success]')) && this.read('rc-club-member-v1') !== 'yes'));
      if(result && this.querySelector('[data-club-success]')) this.store('rc-club-member-v1','yes');
      if(this.editor) {if(this.dataset.preview !== 'off') this.show(); return;}
      if(this.hasResult) this.show();
      this.loadPrivacy(0);
    }
    store(key,value) {try {localStorage.setItem(key,value);} catch {} }
    read(key) {try {return localStorage.getItem(key);} catch {return null;} }
    show() {
      clearTimeout(this.timer);
      if(this.club.open || !this.isConnected) return;
      if(!this.editor && !this.hasResult && (this.read('rc-club-dismissed-v1') || this.read('rc-club-member-v1') === 'yes' || this.dataset.knownMember === 'true')) return;
      this.previousOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      const pageX = window.scrollX, pageY = window.scrollY;
      this.club.showModal();
      this.club.querySelector('[data-close-club]').focus({preventScroll:true});
      window.scrollTo(pageX,pageY);
    }
    hide() {
      if(!this.club?.open) return;
      this.club.close();
      if(this.previousOverflow !== null) document.documentElement.style.overflow = this.previousOverflow;
      this.previousOverflow = null;
    }
    closeClub() {
      this.hide();
      this.hasResult = false;
      if(!this.editor) this.store('rc-club-dismissed-v1',String(Date.now()));
    }
    loadPrivacy(attempt) {
      if(!this.isConnected) return;
      if(window.Shopify?.customerPrivacy) {this.api = window.Shopify.customerPrivacy; this.scheduleClub(); return;}
      if(window.Shopify?.loadFeatures) {
        window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}], error => {
          if(!this.isConnected) return;
          if(!error && window.Shopify.customerPrivacy) {this.api = window.Shopify.customerPrivacy; this.scheduleClub();}
        });
      } else if(attempt < 20) this.retry = setTimeout(() => this.loadPrivacy(attempt+1),500);
    }
    needsConsent() {
      if(!this.api) return true;
      const consent = this.api.currentVisitorConsent();
      const answered = ['analytics','marketing','preferences'].some(key => consent[key] === 'yes' || consent[key] === 'no');
      return this.api.shouldShowBanner() && !answered;
    }
    blocked() {
      return [...document.querySelectorAll('dialog[open],.cc-popup--visible,#shopify-pc__banner,#shopify-pc__prefs')].some(el => el !== this.club && el.getClientRects().length > 0);
    }
    scheduleClub() {
      clearTimeout(this.timer);
      if(this.editor || this.hasResult || this.club.open || this.dataset.enabled !== 'true' || this.dataset.knownMember === 'true' || this.read('rc-club-member-v1') === 'yes' || this.needsConsent()) return;
      if(this.read('rc-club-dismissed-v1')) return;
      this.timer = setTimeout(() => {
        if(document.hidden || this.needsConsent()) return;
        if(this.blocked()) {this.scheduleClub(); return;}
        this.show();
      },Number(this.dataset.delay)*1000);
    }
    disconnectedCallback() {
      clearTimeout(this.timer); clearTimeout(this.retry);
      this.abort?.abort(); this.hide(); this.started = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
